import axios from "axios";

export default {
    get() {
        return axios.get("users");
    },
    store(body) {
        return axios.post("users", body);
    }
};
